import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  Modal,
  ButtonToolbar,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { ParGroupTable } from "./ParGroupTable";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectGroup,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchGroup,
  addGroup,
} from "./businessParameterSlice";
import { showDialog, showErrorDialog, showSuccessDialog } from "../../utility";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { red } from "@material-ui/core/colors";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const ParameterGroupTab = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectGroup);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  const [code, setCode] = useState("");
  const [name, setName] = useState("");



  const handleSearch = async () => {
    let params = {};
    fields.forEach((item) => {
      params[item.params] = item.value;
    });

    params.pageNo = 1;
    params.pageSize = 10;

    try {
      const response = await dispatch(fetchGroup(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
      } else if (
        response.payload.error === "10008" ||
        response.payload.error === "10009"
      ) {
        const action = await showErrorDialog(response.payload.message);
        await history.push("/logout");
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error, "masukcatch");
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {};
      fields.forEach((item) => {
        params[item.params] = item.value;
      });

      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchGroup(params));
        if (response.payload.status === 200) {
        } else if (
          response.payload.error === "10008" ||
          response.payload.error === "10009"
        ) {
          const action = await showErrorDialog(response.payload.message);
          await history.push("/logout");
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
        
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
       
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  // new

  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const [typeOptions, setTypeOptions] = useState([
    {
      id: "1",
      value: "paramgroup_code",
      label: "Group Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "2",
      value: "paramgroup_name",
      label: "Name",
      show: "Y",
      editor: "text",
    },
  ]);

  const data_filter = typeOptions.filter((element) => element.show === "Y");

  const [fields, setFields] = useState([
    { id: "", value: "", params: "", add: "N", editor: "text" },
  ]);

  function handleRemarkChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
  }

  function handleAdd(i, event) {
    const values = [...fields];

    if (values[i].params === "") {
      showDialog("Please select filter first");
    } else {
      // update disabled field
      values[i].add = "Y";
      setFields(values);
      //   change status show

      const result = typeOptions.map((item) => {
        if (item.value === values[i].params) {
          return { ...item, show: "N" };
        }
        return item;
      });

      setTypeOptions(result);

      //   push new paramater
      values.push({ id: "", value: "", params: "", add: "N", editor: "text" });
      setFields(values);
    }
  }

  function handleRemove(i) {
    const values = [...fields];

    const result = typeOptions.map((item) => {
      if (item.value === values[i].params) {
        return { ...item, show: "Y" };
      }
      return item;
    });
    setTypeOptions(result);

    values.splice(i, 1);
    setFields(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].params = event.value;
    values[i].id = event.id;
    values[i].editor = event.editor;
    setFields(values);
  };

  // Func Create
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSave = async () => {
    //Validasi

    if (code === "") {
      return showErrorDialog("Please Input Code First");
    }
    if (name === "") {
      return showErrorDialog("Please Input Name First");
    }

    const params = {
      paramgroup_code: code,
      paramgroup_name: name,
    };
    try {
      const response = await dispatch(addGroup(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.message);
        await window.location.reload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <Button
              className="btn btn-primary my-btn-primary-dark text-bold mb-5"
              onClick={handleShow}
            >
              New Group
            </Button>
            {fields.map((field, idx) => {
              return (
                <div key={`${field}-${idx}`}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={1}>
                      {idx === 0 && <b>Search By</b>}
                    </Form.Label>

                    <Col sm={3}>
                      {fields[idx].add === "N" && (
                        <Select
                          // isClearable={true}
                          options={data_filter}
                          value={getValueType(field.params, typeOptions)}
                          placeholder="Select Field"
                          // onChange={handleTypeChange}
                          onChange={(e) => handleTypeChange(idx, e)}
                        />
                      )}
                      {fields[idx].add === "Y" && (
                        <Form.Control
                          type="text"
                          value={fields[idx].params}
                          disabled
                        />
                      )}
                    </Col>
                    <Col sm={3}>
                      {field.editor === "text" && (
                        <Form.Control
                          type="text"
                          placeholder="Enter text"
                          value={field.value || ""}
                          onChange={(e) => handleRemarkChange(idx, e)}
                        />
                      )}
                    </Col>
                    <Col sm={1}>
                      {fields.length !== 1 && (
                        <div
                          className="btn btn-icon btn-light btn-hover-danger btn-sm "
                          onClick={() => handleRemove(idx)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-danger">
                            <SVG
                              src={toAbsoluteUrl("/media/svg/icons/New/X.svg")}
                            />
                          </span>
                        </div>
                      )}
                    </Col>
                    <Col sm={1}>
                      {fields.length - 1 === idx && (
                        <Button
                          variant="outline-primary"
                          onClick={(e) => handleAdd(idx, e)}
                        >
                          Add
                        </Button>
                      )}
                    </Col>
                    <Col sm={1}>
                      {fields.length - 1 === idx && (
                        <Button
                          className="btn btn-primary"
                          onClick={handleSearch}
                        >
                          Search
                        </Button>
                      )}
                    </Col>
                  </Form.Group>
                </div>
              );
            })}

            {data && data.length > 0 && (
              <ParGroupTable
                 data={data === null ? [] : data}
                page={pageNo}
                sizePerPage={pageSize}
                totalSize={totalRecord}
                onTableChange={handleTableChange}
                loading={loading}
              />
            )}
          </CardBody>
        </Card>

        {/* Modal Create */}
        <Modal
          size="xs"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              New Parameter Group
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <RedditTextField
              label="Code *"
              className={classes.margin}
              variant="filled"
              id="reddit-input"
              size="small"
              fullWidth
              onChange={(e) => setCode(e.target.value)}
              value={code}
            />
            <RedditTextField
              label="Name *"
              className={classes.margin}
              variant="filled"
              id="reddit-input"
              size="small"
              fullWidth
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
